import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import { ventasTypes } from "../../../../../ducks/ventas/";
import ItemEstadoVenta from "./estadoVenta/ItemEstadoVenta";

class EstadoVenta extends Component {
  handleClick = estado => this.props.handleChangeEstadoVenta(estado);

  renderEstados = () =>
    Object.values(ventasTypes.ESTADO_VENTA).map(item => (
      <ItemEstadoVenta key={item} datos={item} handleClick={this.handleClick} />
    ));

  render() {
    return (
      <Table selectable>
        <Table.Body>{this.renderEstados()}</Table.Body>
      </Table>
    );
  }
}

export default EstadoVenta;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/tablaColegios/filaColegios/EstadoVenta.jsx